module.exports = __webpack_public_path__ + "static/img/bg_2.be1b52b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/bg_2.jpg
// module id = rjiP
// module chunks = 3